export enum HeaderTab {
  Character = "Character",
  Settings = "Settings",
}
